"use strict";

import axios from "axios";

export default ({
    fetch(url, data, cb, component){
        axios.post(url, data).then(function (d) {
            cb(null, d && d.data || d);
        }, cb);
    },
    format(){

    },
    value(){

    }
})


/** WEBPACK FOOTER **
 ** ./src/types/bank/BankProcessor.js
 **/